import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import NewPost from '../../components/NewPost';
import EditPost from '../../components/EditPost';
import PostsList from '../../components/PostsList';
import FoldersList from '../../components/FoldersList';

class Post extends Component {
  render() {
    if ( this.props.postId && 'new' === this.props.postId ) {
      return (
        <NewPost {...this.props} />
      )
    } else if (this.props.postId) {
      return (
        <EditPost {...this.props} />
      )
    } else {
      return (
        <div>
          <Typography variant="headline" component="h3">Public posts</Typography>
          <PostsList screen={this.props.screen} visibility="public"/>

          <div style={{height: 60}} />
          <Typography variant="headline" component="h3">Private posts</Typography>
          <PostsList screen={this.props.screen} visibility="private"/>

          <div style={{height: 60}} />
          <Typography variant="headline" component="h3">Folders</Typography>
          <FoldersList {...this.props} />
        </div>
      )
    }
  }
}

export default Post;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/Post/index.js